import React from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { Container, Row, Col, Image, Button } from "react-bootstrap";
import { motion } from "framer-motion";
import { resolveAsset } from "../utils/paths";
import { useNavigate } from "react-router-dom";
import { useDonation } from "../Components/DonationContext";
import "./Volunteers.css";

/* ---- Simple inline icons (no external icon-font dependency) ---- */
const IconLeaf = () => (
  <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M5 21c8 0 14-6 14-14V5h-2C9 5 3 11 3 19v2h2z" />
    <path d="M5 21c4-6 8-9 14-12" />
  </svg>
);

const IconUsers = () => (
  <svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="#1f9d55" strokeWidth="1.8">
    <circle cx="9" cy="8" r="3" />
    <path d="M2.5 20c0-3.5 2.9-6 6.5-6s6.5 2.5 6.5 6" />
    <circle cx="17.5" cy="8.5" r="2.3" />
    <path d="M15.7 14c2.6.4 4.7 2.5 4.7 5.5" />
  </svg>
);

const IconHeartHand = () => (
  <svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="#1f9d55" strokeWidth="1.8">
    <path d="M12 8.5c-1-1.6-3.5-1.6-4.3.2-.7 1.6.7 3 4.3 5.8 3.6-2.8 5-4.2 4.3-5.8-.8-1.8-3.3-1.8-4.3-.2z" />
    <path d="M3 17c1.5-1 3-1 4.5 0l3 1.5c1 .5 2 .5 3 0l6.5-3.3" />
  </svg>
);

const IconSprout = () => (
  <svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="#1f9d55" strokeWidth="1.8">
    <path d="M12 22v-9" />
    <path d="M12 13c0-4 3-6 7-6 0 4-3 6-7 6z" />
    <path d="M12 13C12 9 9 7 5 7c0 4 3 6 7 6z" />
  </svg>
);

const IconUserBadge = () => (
  <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="#1f9d55" strokeWidth="1.8">
    <circle cx="12" cy="8" r="4" />
    <path d="M4 21c0-4.4 3.6-7 8-7s8 2.6 8 7" />
  </svg>
);

const IconGradCap = () => (
  <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="#1f9d55" strokeWidth="1.8">
    <path d="M2 9l10-4 10 4-10 4-10-4z" />
    <path d="M6 11v4c0 1.7 2.7 3 6 3s6-1.3 6-3v-4" />
    <path d="M22 9v6" />
  </svg>
);

const IconBook = () => (
  <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="#1f9d55" strokeWidth="1.8">
    <path d="M4 5.5C4 4.7 4.7 4 5.5 4H12v16H5.5A1.5 1.5 0 014 18.5v-13z" />
    <path d="M20 5.5c0-.8-.7-1.5-1.5-1.5H12v16h6.5a1.5 1.5 0 001.5-1.5v-13z" />
  </svg>
);

const IconStar = () => (
  <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="#1f9d55" strokeWidth="1.8">
    <path d="M12 3l2.6 5.6 6.1.6-4.6 4.1 1.3 6-5.4-3.1-5.4 3.1 1.3-6-4.6-4.1 6.1-.6z" />
  </svg>
);

const IconTarget = () => (
  <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="#1f9d55" strokeWidth="1.8">
    <circle cx="12" cy="12" r="8" />
    <circle cx="12" cy="12" r="4" />
    <circle cx="12" cy="12" r="0.6" fill="#1f9d55" />
  </svg>
);

const IconUserPlus = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="9" cy="8" r="3.2" />
    <path d="M2.5 20c0-3.6 2.9-6.2 6.5-6.2s6.5 2.6 6.5 6.2" />
    <path d="M18 8v5M20.5 10.5h-5" />
  </svg>
);

const IconHeartFilled = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M12 21s-7.5-4.6-10-9.3C.4 8.6 2 5 5.6 5c2 0 3.4 1.1 4.4 2.6C11 6.1 12.4 5 14.4 5 18 5 19.6 8.6 22 11.7 19.5 16.4 12 21 12 21z" />
  </svg>
);

const ways = [
  { title: "Participate", text: "Be a part of change", icon: <IconUsers /> },
  { title: "Contribute", text: "Share your skills & time", icon: <IconHeartHand /> },
  { title: "Encourage", text: "Inspire a better tomorrow", icon: <IconSprout /> },
];

const volunteers = [
  "Ms Elena de Fillipo (Development Studies): Volunteered @ Gop CBR Project",
  "Mr Luca Galassi (Development Studies): Volunteered @ Gop CBR Project",
  "Mr Uttam Kumar (MSW): Interned @ Malkangiri Livelihood Project",
  "Mr Maheswar Majhi (MSW): Interned @ Malkangiri Livelihood Project",
  "Mr Bijay K Sahoo (MSW): Interned @ Malkangiri Livelihood Project",
  "Mr Brajakishore Patra (MSW): Interned @ Malkangiri Livelihood Project",
  "Ms P. Jyoti (MSW): Interned @ Malkangiri Livelihood Project",
  "Mr Sanidhya Dash (B.tech): Interned @ Bhubaneswar Fundraising",
  "Mr Swadhin Pattanayak (B.tech): Interned @ Bhubaneswar Fundraising",
  "Mr Sabyasachi Sahoo (B.tech): Interned @ Bhubaneswar Fundraising",
];

const cta_highlights = [
  { icon: <IconBook />, text: "Learn" },
  { icon: <IconStar />, text: "Gain Experience" },
  { icon: <IconTarget />, text: "Make an Impact" },
];

const Volunteers = () => {
  const navigate = useNavigate();
  const { openDonation } = useDonation();

  return (
    <>
      <Header />

      {/* Start Page Header */}
      <section className="page-header page-header--vol">
        <div
          className="page-header__bg"
          style={{
            backgroundImage: "url(/assets/images/backgrounds/Volunter_1521x482.jpg)",
          }}
        ></div>
        <div className="shape1 float-bob-x">
          <img
            src="assets/images/shapes/page-header-shape1.png"
            alt=""
            style={{ filter: "hue-rotate(90deg)" }}
          />
        </div>
        <div className="shape2">
          <img
            src="assets/images/shapes/page-header-shape2.png"
            alt=""
            style={{ filter: "hue-rotate(90deg)" }}
          />
        </div>
        <div className="container">
          <div className="page-header__inner">
            <motion.h2
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7 }}
            >
              Volunteers
            </motion.h2>
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.3 }}
              style={{ color: "#dad2d0", fontSize: "24px", marginTop: "20px" }}
            >
              Join Vikash as a volunteer and make a difference! Contribute
              your skills to support community initiatives and help create
              lasting positive change.
            </motion.p>
          </div>
        </div>
      </section>
      {/* End Page Header */}

      <Container className="my-5">
        {/* Ways to help Section */}
        <Row className="g-4 mb-5 vol-ways-row">
          {ways.map((item, index) => (
            <Col md={4} key={index}>
              <div className="vol-way-card">
                <div className="vol-way-icon">{item.icon}</div>
                <h5>{item.title}</h5>
                <p>{item.text}</p>
              </div>
            </Col>
          ))}
        </Row>

        {/* Intro text */}
        <Row className="mb-4">
          <Col>
            <p className="vol-intro-text text-center">
              We are committed to promoting volunteerism. Volunteers and
              interns are encouraged to work with us, and some of our
              projects offer <strong>Paid Internships</strong> to gain
              valuable experience while contributing to the community.
            </p>

            <div className="vol-section-heading text-center">
              <h3>
                Friends who inspired us as{" "}
                <span className="text-success">Volunteers/Interns</span> in
                2019
              </h3>
              <div className="vol-heading-underline">
                <IconLeaf />
              </div>
            </div>

            <Row className="g-3">
              {volunteers.map((volunteer, index) => {
                const [namePart, afterAt] = volunteer.split("@");
                const nameMatch = namePart.match(/^(.*?)\s*\((.*?)\):\s*(.*)$/);
                const name = nameMatch ? nameMatch[1] : namePart;
                const qualification = nameMatch ? nameMatch[2] : "";
                const role = nameMatch ? nameMatch[3] : "";

                return (
                  <Col xs={12} md={6} lg={4} key={index}>
                    <div
                      className="volunteer-card"
                      ref={(el) => {
                        if (el) {
                          const observer = new IntersectionObserver(
                            ([entry]) => {
                              if (entry.isIntersecting) {
                                el.style.opacity = 1;
                                el.style.transform = "translateY(0)";
                                observer.unobserve(el);
                              }
                            },
                            { threshold: 0.1 }
                          );
                          observer.observe(el);
                        }
                      }}
                    >
                      <span className="volunteer-card__icon">
                        <IconUserBadge />
                      </span>
                      <div>
                        <h6>{name}</h6>
                        <span className="volunteer-card__qualification">
                          <IconGradCap /> {qualification}
                        </span>
                        <p>
                          {role} <span className="text-success">@{afterAt}</span>
                        </p>
                      </div>
                    </div>
                  </Col>
                );
              })}
            </Row>
          </Col>
        </Row>

        {/* Image Gallery Section */}
        <div className="vol-section-heading text-center mb-4">
          <h3>
            <IconLeaf /> Moments from Our Volunteer Activities
          </h3>
          <div className="vol-heading-underline vol-heading-underline--center">
            <IconLeaf />
          </div>
        </div>
        <Row className="g-3">
          {["v1.jpg", "v2.png", "v3.jpg", "v4.jpg", "v5.jpg", "v6.png"].map((fileName) => (
            <Col xs={6} md={4} lg={2} key={fileName}>
              <Image
                src={resolveAsset(`assets/images/Vl/${fileName}`)}
                fluid
                rounded
                className="vol-gallery-img"
                ref={(el) => {
                  if (el) {
                    const observer = new IntersectionObserver(
                      ([entry]) => {
                        if (entry.isIntersecting) {
                          el.style.opacity = 1;
                          el.style.transform = "translateY(0)";
                          observer.unobserve(el);
                        }
                      },
                      { threshold: 0.1 }
                    );
                    observer.observe(el);
                  }
                }}
              />
            </Col>
          ))}
        </Row>

        {/* CTA Section */}
        <div className="vol-cta-box mt-5">
          <div className="vol-cta-leaf">
            <IconLeaf />
          </div>
          <Row className="align-items-center g-4">
            <Col lg={6}>
              <h2 className="vol-cta-heading">
                Be the Change. <span className="text-success">Volunteer</span>{" "}
                With Us!
              </h2>
              <div className="vol-heading-underline">
                <IconLeaf />
              </div>
              <p className="vol-cta-text">
                Your time and talent can create a stronger, healthier and
                more inclusive community.
              </p>
              <div className="vol-cta-buttons">
                <Button
                  className="vol-btn vol-btn--solid"
                  type="button"
                  onClick={() => navigate("/interns")}
                >
                  <IconUserPlus /> Join as a Volunteer
                </Button>
                <Button
                  className="vol-btn vol-btn--outline"
                  type="button"
                  onClick={openDonation}
                >
                  <IconHeartFilled /> Support Our Mission
                </Button>
              </div>
            </Col>
            <Col lg={6}>
              <div className="vol-cta-image-wrap">
                <img
                  src="/assets/images/backgrounds/volin.png"
                  alt="Vikash volunteers group"
                  className="vol-cta-image"
                />
                <div className="vol-cta-highlights">
                  {cta_highlights.map((h, idx) => (
                    <div className="vol-cta-highlights__item" key={idx}>
                      <span className="vol-cta-highlights__icon">{h.icon}</span>
                      <span>{h.text}</span>
                    </div>
                  ))}
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </Container>

      <Footer />

      <a
        href="#"
        data-target="html"
        className="scroll-to-target scroll-to-top"
      >
        <span className="scroll-to-top__wrapper">
          <span className="scroll-to-top__inner" />
        </span>
        <span className="scroll-to-top__text"> Go Back Top</span>
      </a>
    </>
  );
};

export default Volunteers;